export default __webpack_public_path__ + "static/media/img_ts_04_m.632baf0a.png";